import { AuthService, ReplaceableComponentsService } from '@abp/ng.core';
import { Component, inject, Injector, ViewChild } from '@angular/core';
import { eThemeLeptonXComponents, eUserMenuItems } from '@volosoft/abp.ng.theme.lepton-x';
import { UserMenuService } from '@abp/ng.theme.shared';
import { AppBaseComponent } from './shared/app-base.component';
import { ChangePlaceModalComponent } from './shared/components/change-place-modal/change-place-modal.component';
import { CareerCompetenciesBreadcrumbComponent } from './shared/components/career-competencies-breadcrumb/career-competencies-breadcrumb.component';
import { AppConsts } from './shared/AppConsts';
import { PrimeNG } from 'primeng/config';
import { PRIMENG_ES } from './i18n/primeng-es';


@Component({
    selector: 'app-root',
    template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
    <abp-gdpr-cookie-consent></abp-gdpr-cookie-consent>
    <app-change-place-modal></app-change-place-modal>
    <ngx-spinner type="ball-clip-rotate" color="#F8F7EE" size="default"></ngx-spinner>
  `,
    standalone: false
})
export class AppComponent extends AppBaseComponent {

  @ViewChild(ChangePlaceModalComponent) changePlaceModal: ChangePlaceModalComponent;

  private readonly primengConfig = inject(PrimeNG);
  
  constructor(
    injector: Injector,
    private readonly replaceableComponents: ReplaceableComponentsService,
    private readonly _userMenu: UserMenuService,
    readonly _authService: AuthService) {
      super(injector);
      if (!_authService.isAuthenticated) {
        _authService.navigateToLogin();
      }

      this.primengConfig.setTranslation(PRIMENG_ES)
      this.removeComponents();
      this.removeUserMenuItems();
  }

  private removeUserMenuItems(): void {
    this._userMenu.removeItem(eUserMenuItems.MyAccount);
    this._userMenu.removeItem(eUserMenuItems.LinkedAccounts);
    this._userMenu.removeItem(eUserMenuItems.SecurityLogs);
    this._userMenu.removeItem(eUserMenuItems.AuthorityDelegation);
    this._userMenu.removeItem(eUserMenuItems.Sessions);
    this._userMenu.removeItem(eUserMenuItems.ExternalLogins);
    this._userMenu.removeItem(eUserMenuItems.BackToImpersonator);
    this._userMenu.removeItem(AppConsts.GdprNavigationMenuItemName);

    this._userMenu.addItems([
      {
        order: 0,
        name: AppConsts.ChangeCurrentPlaceMenuItemName,
        textTemplate: {
          text: this.l('::ChangeCurrentPlace'),
          icon: 'fas fa-map-marker-alt',
        },
        id: AppConsts.ChangeCurrentPlaceMenuItemName,
        action: () => {
          this.changePlaceModal.show();
        }
      }
    ]);
  }

  private removeComponents(): void {
    this.replaceableComponents.add({
      component: undefined,
      key: eThemeLeptonXComponents.Settings,
    });

    this.replaceableComponents.add({
      component: CareerCompetenciesBreadcrumbComponent,
      key: eThemeLeptonXComponents.Breadcrumb,
    });

    this.replaceableComponents.add({
      component: undefined,
      key: eThemeLeptonXComponents.MobileNavbarSettings,
    });

    this.replaceableComponents.add({
      component: undefined,
      key: eThemeLeptonXComponents.Footer,
    })
  }
}
